/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConcessionsFlatCents
 */
export interface ConcessionsFlatCents {
}

/**
 * Check if a given object implements the ConcessionsFlatCents interface.
 */
export function instanceOfConcessionsFlatCents(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ConcessionsFlatCentsFromJSON(json: any): ConcessionsFlatCents {
    return ConcessionsFlatCentsFromJSONTyped(json, false);
}

export function ConcessionsFlatCentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConcessionsFlatCents {
    return json;
}

export function ConcessionsFlatCentsToJSON(value?: ConcessionsFlatCents | null): any {
    return value;
}

